import React from "react";
import { connect  } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, LogOut, Mail, User } from "lucide-react";
import { logoutRequest } from "../../../../redux/auth/authState";

const ProfileHeader = ({authUser, logout}) => {
  const navigate = useNavigate();

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <button
          onClick={() => navigate("/job-posts")}
          className="inline-flex items-center justify-center gap-2 rounded-lg text-sm font-medium 
                     h-9 px-4 py-2 mb-2 bg-white hover:bg-gray-100"
        >
          <ArrowLeft className="w-4 h-4" /> Back to all jobs
        </button>

        <button
          onClick={() => logout()}
          className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-lg 
                    text-sm font-medium transition-all border bg-background text-foreground h-9 
                    px-4 py-2 hover:bg-red-50 hover:text-red-600 hover:border-red-300"
        >
          <LogOut className="w-4 h-4" /> Sign Out
        </button>
      </div>

      <div className="bg-white flex flex-col gap-6 rounded-xl border p-6">
        <div className="flex items-start gap-6">
          <div className="w-20 h-20 bg-gradient-to-r from-purple-600 to-emerald-600 rounded-2xl flex items-center justify-center flex-shrink-0">
            <User className="w-10 h-10 text-white" />
          </div>
          <div className="flex-1">
            <h2 className="text-gray-900 text-xl font-medium mb-2">
              { authUser?.name }
            </h2>
            <div className="flex items-center gap-2 text-gray-800">
              <Mail className="w-4 h-4" />
              <span>{authUser?.email}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  authUser: state.auth.user,
});

const mapDispatchToProps = (dispatch) => ({
  logout: () => dispatch(logoutRequest()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ProfileHeader);
